import PropTypes from 'prop-types';
import { NavLink as RouterLink } from 'react-router-dom';

// @mui
import { Box, List, ListItemText } from '@mui/material';
//
import { StyledNavItem, StyledNavItemIcon } from './styles';

// ----------------------------------------------------------------------

NavSection.propTypes = {
  data: PropTypes.array,
};

export default function NavSection({ data = [], ...other }) {
  const hasAccess = (screenName) => {
    const access = sessionStorage.getItem(`${screenName}`) === 'Y';
    return access;
  };
  return (
    <Box {...other}>
      <List disablePadding sx={{ px: 1 }}>
        {/* {data
          .filter((item) => hasAccess(item.ShortName))
          .map((item) => (
            <NavItem key={item.title} item={item} />
          ))} */}

        {data.map((item) => (
          <NavItem key={item.title} item={item} />
        ))}
      </List>
    </Box>
  );
}

// ----------------------------------------------------------------------

NavItem.propTypes = {
  item: PropTypes.object,
};

function NavItem({ item }) {
  const { title, path, icon, info } = item;

  return (
    <StyledNavItem
      component={RouterLink}
      to={path}
      sx={{
        '&.active': {
          color: '#EEEEEE',
          py: 3,
          // color: 'text.primary',
          bgcolor: '#6482AD',
          // bgcolor: 'action.selected',
          fontWeight: 'fontWeightBold',
        },
        mb: 1,
      }}
    >
      <StyledNavItemIcon>{icon && icon}</StyledNavItemIcon>

      <ListItemText disableTypography primary={title} sx={{ fontSize: 'small' }} />

      {info && info}
    </StyledNavItem>
  );
}
